import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function initCardSwiper() {
  // Инициализация миниатюр
  const thumbsSwiper = new Swiper(".avtoCard__slider2", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    allowTouchMove: false,
  });

  // Основной слайдер
  const mainSwiper = new Swiper(".avtoCard__slider", {
    navigation: {
      nextEl: ".avtoCard-button-next",
      prevEl: ".avtoCard-button-prev",
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
    observer: true,
    observeParents: true,
    allowTouchMove: false,
  });

  // Динамическая галерея Fancybox
  const slides = document.querySelectorAll(".avtoCard__slider .swiper-slide img");
  const fancyboxItems = Array.from(slides).map(img => ({ src: img.src }));

  slides.forEach((img, i) => {
    img.addEventListener("click", () => {
      Fancybox.show(fancyboxItems, {
        Thumbs: false,
        Toolbar: true,
        startIndex: i, // открываем слайд по индексу
      });
    });
  });
}
